import { RedirectFunction, Route } from '@angular/router';

// Typescript really should make this easier...  To add new properties, add name to
// array here and then to both RootRoute interface + RootRouteData class below.
export const RootRouteProperties = ['page', 'headerStyle'];

export interface RootRoute extends Route {
    /**
     * The page name to use for content lookup.
     */
    page?: string;

    /**
     * The header style to use for the page.
     */
    headerStyle?: HeaderStyle;
}

/**
 * Supports configuration via the data properties allowed in a route
 * this is similar to the properties we used to use in routeConfig.js in AngularJS
 */
export class RootRouteData {
    /**
     * The page name to use for content lookup.
     */
    page?: string;

    /**
     * The header style to use for the page.
     */
    headerStyle?: HeaderStyle;
}

/**
 * Supports catch-all routes, where a standard route has marketing information added on the end
 * of it that should not influence behavior.
 */
export class CatchAllRouteData {
    /**
     * URL to redirect to after logging the catch-all route was hit.
     */
    redirectTo: string | RedirectFunction = '';
}

export enum HeaderStyle {
    None = 'none',
    Standard = 'standard',
    Landing = 'landing',
    PreEnrollment = 'preenrollment',
    PreEnrollmentSummary = 'preenrollmentsummary',
}

export const ROOT_ROUTE_DATA = {
    BASE_PATH: '/',
    LANDING: {
        PATH: '',
        PAGE: 'Landing',
    },
    PREENROLLMENT: {
        PATH: 'pre-enrollment/:preEnrollmentId',
        PAGE: 'PreEnrollment',
        TITLE: 'Benefits For You - PreEnrollment',
    },
    PREENROLLMENT_SUMMARY: {
        PATH: 'pre-enrollment-summary',
        PAGE: 'PreEnrollment',
        TITLE: 'Benefits For You - PreEnrollmentSummary',
    },
    LOGOUT: {
        PATH: 'log-out',
    },
};
